import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { ERROR_MESSAGE } from "../../../constants/errorMessage";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";
import { AppDispatch } from "../../../store";
import { validateEmail } from "../../../utils/validation";

export const useForgotPassword = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();
  const { email } = state ?? {};

  const handleForgotPassword = useCallback(
    (email: string, onError: (message: string) => void) => {
      const isValidEmail = validateEmail(email);

      if (!isValidEmail) return onError(ERROR_MESSAGE.invalidEmail);

      dispatch(appActions.showLoading());

      dispatch(
        authActions.sendResetPasswordEmail.started({
          email,
          onComplete: () => dispatch(appActions.hideLoading()),
          onSuccess: ({ success }) => {
            dispatch(
              appActions.showNotification({
                type: success ? "success" : "failed",
                message: success
                  ? "パスワード再設定用のメールを送信しました"
                  : "メールの送信に失敗しました",
              }),
            );
            if (success) {
              navigateToPage(PageRoutes.FORGOT_PASSWORD_SEND_MAIL, false);
            }
          },
        }),
      );
    },
    [],
  );

  const handleCancel = useCallback(() => {
    navigateToPage(PageRoutes.LOGIN_PASSWORD, false, { email });
  }, []);

  return { email, handleForgotPassword, handleCancel };
};
